import type { App } from 'vue'
import { useUserStore } from '@/store'

/**
 * Register permission directive.
 * Usage: v-permission="'system:user:create'"
 */
export default function setupPermissionDirective(app: App) {
  app.directive('permission', {
    mounted(el, binding) {
      const userStore = useUserStore()
      const requiredPermission = binding.value as string

      if (!requiredPermission) return

      const permissions = userStore.permissions
      if (!permissions.includes(requiredPermission)) {
        el.parentElement?.removeChild(el)
      }
    },
  })
}
